import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

declare global {
  interface Window {
    grecaptcha: {
      enterprise: {
        ready: (callback: () => void) => void;
        execute: (key: string, options: { action: string }) => Promise<string>;
      };
    };
  }
}

@Injectable({
  providedIn: 'root',
})
export class RecaptchaService {
  private readonly maxAttempts = 20;
  private readonly intervalMs = 100;


  private waitForGreCaptcha(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      let attempts = 0;

      const check = () => {
        const hasGreCaptcha =
          window.grecaptcha &&
          window.grecaptcha.enterprise &&
          typeof window.grecaptcha.enterprise.ready === 'function';

        if (hasGreCaptcha) {
          window.grecaptcha.enterprise.ready(() => resolve());
          return;
        }

        attempts++;
        if (attempts >= this.maxAttempts) {
          reject(new Error('reCAPTCHA Enterprise não está disponível.'));
        } else {
          setTimeout(check, this.intervalMs);
        }
      };

      check();
    });
  }

  /**
   * Sempre gera um novo token para a action informada.
   */
  getToken(action: string): Promise<string> {
    return this.waitForGreCaptcha().then(() => {
      return window.grecaptcha.enterprise.execute(environment.reCaptchaKey, { action });
    });
  }
}
